import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Form, Input, Button, Card, message, Typography } from 'antd';
import { MailOutlined } from '@ant-design/icons';

import PageTitle from '../Layouts/PageTitle';
import adminService from '../../services/admin.service';

const { Title, Text } = Typography;

const ForgotPassword: React.FC = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const onFinish = async (values: { email: string }) => {
    try {
      setLoading(true);
      await adminService.requestPasswordReset(values.email);
      setSubmitted(true);
    } catch (error) {
      console.error('Failed to request password reset:', error);
      message.error('Failed to send password reset. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageTitle title="Forgot Password">
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Card style={{ maxWidth: 400, width: '100%', margin: '10px', boxShadow: '0 4px 8px rgba(0,0,0,0.1)' }}>
          {!submitted ? (
            <>
              <Title level={2} style={{ textAlign: 'center', marginBottom: 24 }}>
                Reset Password
              </Title>
              <Text style={{ display: 'block', marginBottom: 24 }}>
                Enter your email address and we'll send you instructions to reset your password.
              </Text>
              <Form form={form} name="forgot_password" onFinish={onFinish} layout="vertical">
                <Form.Item
                  name="email"
                  rules={[
                    { required: true, message: 'Please enter your email.' },
                    { type: 'email', message: 'Please enter a valid email.' },
                  ]}
                >
                  <Input prefix={<MailOutlined />} placeholder="Email" size="large" />
                </Form.Item>

                <Form.Item>
                  <Button type="primary" size="large" htmlType="submit" loading={loading} block>
                    Send Reset Instructions
                  </Button>
                </Form.Item>

                <div style={{ textAlign: 'center', fontSize: 14 }}>
                  <Link to="/sign-in">Back to login</Link>
                </div>
              </Form>
            </>
          ) : (
            <>
              <Title level={2} style={{ textAlign: 'center', marginBottom: 24 }}>
                Check Your Email
              </Title>
              <Text style={{ display: 'block', marginBottom: 24 }}>
                If an account exists with that email address, we've sent instructions to reset your
                password. Please check your email (including spam folder).
              </Text>
              <div style={{ textAlign: 'center', marginTop: 24 }}>
                <Link to="/sign-in">Back to login</Link>
              </div>
            </>
          )}
        </Card>
      </div>
    </PageTitle>
  );
};

export default ForgotPassword;
